<template>
  <div class="c-header">
    <van-nav-bar
      :safe-area-inset-top="true"
      :left-text="leftText"
      :right-text="rightText"
      :title="title"
      :class="bgColor"
      :border="border"
      :left-arrow="leftArrow"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #right>
        <slot name="rightBar"/>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
import { NavBar } from 'vant';
export default {
  name: 'CHeader',
  components: {
    [NavBar.name]: NavBar
  },
  props: {
    leftText: {
      type: String,
      default: ''
    },
    rightText: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    /**
     * 导航背景色
     * 传入 white 即背景白色 图标/字体均为黑色
     * 传入 blue 即背景蓝色 图标/字体均为白色
     */
    bgColor: {
      type: String,
      default: 'white'
    },
    /**
     * 判断返回的页面
     * 是否返回上一页
     */
    back: {
      type: Boolean,
      default: false
    },
    // 是否显示下边框
    border: {
      type: Boolean,
      default: true
    },
    leftArrow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      prevRouterPath: ''
    };
  },
  watch: {
    $route(val, old) {
      console.log('val', val);
      console.log('old', old);
      this.prevRouterPath = old.fullPath;
    }
  },
  methods: {
    /**
     * 点击左边icon
     * 返回上一层级
     */
    onClickLeft() {
      console.log('this.back', this.back);
      if (!this.back) {
        console.log('window.history.length', window.history.length);
        if (window.history.length > 1) {
          let referrer = this.prevRouterPath;
          console.log('referrer', referrer);
          console.log('referrer', typeof referrer);
          if (referrer.indexOf('login') > -1) {
            if (window.location.href.indexOf('code=') > -1) {
              let code = window.location.href.split('code=')[1].split('&')[0];
              this.$router.push(`/course/index?code=${code}`);
            } else {
              this.$router.push('/course/index');
            }
          } else {
            this.$router.go(-1);
          }
        } else {
          if (window.location.href.indexOf('code=') > -1) {
            let code = window.location.href.split('code=')[1].split('&')[0];
            this.$router.push(`/course/index?code=${code}`);
          } else {
            this.$router.push('/course/index');
          }
        }
      } else {
        this.$emit('back');
      }
    },
    onClickRight() {
      this.$emit('click-right');
    }
  }
};
</script>
<style scoped lang="scss">
.c-header {
  /deep/ .van-nav-bar__title {
    font-weight: bold;
    font-size: 36px;
  }

  .white {
    background-color: $white;
    color: $black;

    /deep/ .van-icon {
      color: $black;
      font-size: 40px;
    }

    /deep/ .van-nav-bar__title {
      color: #1e1e1e;
    }
  }

  .clear {
    background-color: rgba($color: #000000, $alpha: 0);
    color: white;

    /deep/ .van-icon {
      color: white;
      font-size: 40px;
    }

    /deep/ .van-nav-bar__title {
      color: white;
    }

    /deep/ .van-nav-bar__text {
      color: white;
    }
  }

  .blue {
    background-color: $blue;
    color: $white;

    /deep/ .van-icon {
      color: $white;
      font-size: 40px;
    }

    /deep/ .van-nav-bar__title {
      color: $white;
      font-size: 36px;
      font-weight: 600;
    }

    /deep/ .van-nav-bar__right {
      font-size: 32px;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue